import React from "react"
import styles from "./StripeAccountCard.module.css"
import imageEmail from "assets/icons/email-icon.svg"
import PropTypes from "prop-types"
import { CircledIcon } from "ui/CircledIcon"

export const StripeDetails = ({ stripeEmail, isStripeChargeEnabled, errorStripeMessage, stripeLink }) => {
      
  return (
    <div className={styles.stripeInfo}>
      {stripeEmail && (
        <p>
          <strong>
            <img src={imageEmail} width="16px" className="flex-shrink-0" alt="Email" /> |
          </strong>{" "}
          {stripeEmail}
        </p>
      )}

      {errorStripeMessage && (
        <p>
          <strong className={styles.errorMessage}>{errorStripeMessage}</strong>
        </p>
      )}
      {stripeLink && (
        <div>
          <a href={stripeLink} target="_blank" rel="noopener noreferrer">
            Login to Stripe
          </a>
        </div>
      )}
    <div className={styles.chargeStatus}>
  {isStripeChargeEnabled !== undefined && (
    <CircledIcon
      name={isStripeChargeEnabled ? "Check" : "AlertCircle"}
      colorType={isStripeChargeEnabled ? "success" : "error"}
    />
  )}
</div>

    </div>
  )
}

StripeDetails.propTypes = {
  stripeEmail: PropTypes.string,
  isStripeChargeEnabled: PropTypes.bool,
  errorStripeMessage: PropTypes.string,
  stripeLink: PropTypes.string,
}
